import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles.css';
import i18n from './i18n';
import router from './router';
import authService from './auth/authService';

async function bootstrap() {
  await authService.init();

  const app = createApp(App);
  app.use(i18n);
  app.use(router);
  app.mount('#app');
}

bootstrap();
